import React from 'react';
import styled from 'styled-components';
import { Grid } from '../../../app/StyleGuide';
import { sanitizeHTML } from '../../../utils/sanitizeHTML';
import {
  FONT_SIZE_SCALE,
  PrintColors,
  PrintIcon,
  PrintSettings,
  PrintSubTitle,
  SegmentHeaderContainer,
} from './PrintElements';

const TipContainer = styled.div<{ fontSize: keyof typeof FONT_SIZE_SCALE }>`
  width: 100%;
  padding: ${({ fontSize }) => (fontSize < 12 ? Grid._4 : Grid._5)};
  border: 2px solid ${PrintColors.LightGray};
  border-radius: ${PrintSettings.borderRadius};
  display: flex;
  flex-direction: column;
  gap: ${({ fontSize }) => (fontSize < 12 ? Grid._1 : Grid._2)};
  font-size: ${({ fontSize }) => FONT_SIZE_SCALE[fontSize].base};
  height: fit-content;

  @media print {
    ${SegmentHeaderContainer} {
      page-break-before: avoid;
      break-before: avoid;
      break-before: avoid-page;
    }
  }

  p {
    margin: 0;
    font-size: ${({ fontSize }) => FONT_SIZE_SCALE[fontSize].body};
  }
`;

export default function Tip({
  text,
  tipType,
  fontSize,
}: {
  text: string;
  tipType: string;
  fontSize: keyof typeof FONT_SIZE_SCALE;
}) {
  return (
    <TipContainer fontSize={fontSize}>
      <SegmentHeaderContainer>
        <PrintIcon className="fas fa-lightbulb" color={PrintColors.LightGray} fontSize={fontSize} />
        <PrintSubTitle fontSize={fontSize}>{tipType}</PrintSubTitle>
      </SegmentHeaderContainer>
      <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(text ?? '') }} />
    </TipContainer>
  );
}
